import { createFlexibleBenefit } from '../flexibleBenefits/mutations/createFlexibleBenefit';
import { getFlexibleBenefitsList } from './queries/getFlexibleBenefitList';
import { getFlexibleBenefit } from './queries/getFlexibleBenefit';
import { getEffectiveSetting } from './flexibleBenefitsSettings/queries/getEffectiveSetting';
import { listEffectiveSettings } from './flexibleBenefitsSettings/queries/listEffectiveSettings';
import { listOverrides } from './flexibleBenefitsSettings/queries/listOverrides';
import { getOverride } from './flexibleBenefitsSettings/queries/getOverride';
import { getEmployeesForOverride } from './flexibleBenefitsSettings/queries/getEmployeesForOverride';
import { updateFlexibleBenefit } from './mutations/updateFlexibleBenefit';
import { getAssignedFlexibleComponentsList } from './queries/getAssignedFlexibleComponentList';
import { updateFlexibleBenefitStatus } from './mutations/updateFlexibleBenefitStatus';
import { updateFlexibleBenefitsSettings } from './flexibleBenefitsSettings/mutations/updateFlexibleBenefitsSettings';
import { bulkUpdateSettings } from './flexibleBenefitsSettings/mutations/bulkUpdateSettings';
import { createOverride } from './flexibleBenefitsSettings/mutations/createOverride';
import { updateOverride } from './flexibleBenefitsSettings/mutations/updateOverride';
import { deleteOverride } from './flexibleBenefitsSettings/mutations/deleteOverride';
import { addEmployeesToOverride } from './flexibleBenefitsSettings/mutations/addEmployeesToOverride';
import { removeEmployeesFromOverride } from './flexibleBenefitsSettings/mutations/removeEmployeesFromOverride';
import { getFlexibleBenefitAssignedComponents } from './queries/getFlexibleBenefitAssignedComponents';
import { uploadClaimEvidenceFiles } from './mutations/uploadClaimEvidenceFiles';
import { createFlexiReimbursementClaim } from './mutations/createFlexiReiumbersementClaim';
import { editFlexiReimbursementClaim } from './mutations/editFlexiReiumbursementClaim';
import { getFlexiReimbursementClaim } from './queries/getFlexiReiumbersmentClaim';
import { getClaimEvidenceFiles } from './queries/getClaimEvidenceFiles';
import { createBulkFlexibleComponentsAssignments } from './mutations/createBulkFlexibleAssignments';
import { updateBulkFlexibleComponentsAssignments } from './mutations/updateBulkFlexibleAssignments';
import { removeBulkFlexibleComponentsAssignments } from './mutations/removeBulkFlexibleAssignments';
import { declareBulkComponentsValues } from './mutations/declareBulkValues';

const mutations = {
  createFlexibleBenefit,
  updateFlexibleBenefit,
  updateFlexibleBenefitStatus,
  createBulkFlexibleComponentsAssignments,
  updateBulkFlexibleComponentsAssignments,
  removeBulkFlexibleComponentsAssignments,
  declareBulkComponentsValues,
  updateFlexibleBenefitsSettings,
  bulkUpdateSettings,
  createOverride,
  updateOverride,
  deleteOverride,
  addEmployeesToOverride,
  removeEmployeesFromOverride,
  uploadClaimEvidenceFiles,
  createFlexiReimbursementClaim,
  editFlexiReimbursementClaim,
};

const queries = {
  getFlexibleBenefitsList,
  getFlexibleBenefit,
  getAssignedFlexibleComponentsList,
  getEffectiveSetting,
  listEffectiveSettings,
  listOverrides,
  getOverride,
  getEmployeesForOverride,
  getFlexiReimbursementClaim,
  getClaimEvidenceFiles,
  getFlexibleBenefitAssignedComponents,
};

const exports = {
  mutations,
  queries,
};

export default exports;
